// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PnMShiftItemShimerCmp$PorterinFeature from "./PnMShiftItemShimerCmp.mjs";
import * as PnMHomePageShimmerModuleScss from "../../styles/PnMHomePageShimmer.module.scss";
import * as PnmShiftItemFooterShimmerCmp$PorterinFeature from "./PnmShiftItemFooterShimmerCmp.mjs";

var styles = PnMHomePageShimmerModuleScss;

function PnMHomePageShimmerCmp(Props) {
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: styles["page-header"]
                }, React.createElement("div", {
                      className: styles["page-header-main"]
                    }, React.createElement("div", {
                          className: styles["back-icon"]
                        }), React.createElement("div", {
                          className: styles.title
                        })), React.createElement("div", {
                      className: styles["booking-flow-stage-container"]
                    }, React.createElement("div", {
                          className: styles["booking-flow-stage-main"]
                        }, React.createElement("div", {
                              className: styles["stage-icon"]
                            }), React.createElement("div", {
                              className: styles["stage-desc"]
                            })), React.createElement("div", {
                          className: styles["divider-dashed"]
                        }), React.createElement("div", {
                          className: styles["booking-flow-stage-main"]
                        }, React.createElement("div", {
                              className: styles["stage-icon"]
                            }), React.createElement("div", {
                              className: styles["stage-desc"]
                            })), React.createElement("div", {
                          className: styles["divider-dashed"]
                        }), React.createElement("div", {
                          className: styles["booking-flow-stage-main"]
                        }, React.createElement("div", {
                              className: styles["stage-icon"]
                            }), React.createElement("div", {
                              className: styles["stage-desc"]
                            })))), React.createElement("div", {
                  className: styles.container
                }, React.createElement("div", {
                      className: styles["shift-item-header"]
                    }, React.createElement("div", {
                          className: styles["main-tile"]
                        }), React.createElement("div", {
                          className: styles.tile
                        }), React.createElement("div", {
                          className: styles.tile
                        }), React.createElement("div", {
                          className: styles.tile
                        })), React.createElement(PnMShiftItemShimerCmp$PorterinFeature.make, {}), React.createElement(PnMShiftItemShimerCmp$PorterinFeature.make, {}), React.createElement(PnMShiftItemShimerCmp$PorterinFeature.make, {}), React.createElement("div", {
                      className: styles["item-footer-container"]
                    }, React.createElement(PnmShiftItemFooterShimmerCmp$PorterinFeature.make, {})), React.createElement("div", {
                      className: styles["footer-container"]
                    }, React.createElement("div", {
                          className: styles["footer-tile-container"]
                        }, React.createElement("div", {
                              className: styles["footer-tile"]
                            })), React.createElement("button", {
                          className: styles["footer-cta"]
                        }, "Confirm items"))));
}

var make = PnMHomePageShimmerCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
